import { render, staticRenderFns } from "./SettingShippingFee.vue?vue&type=template&id=75d3a0d2"
import script from "./SettingShippingFee.vue?vue&type=script&lang=js"
export * from "./SettingShippingFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports